import React from "react"
import { useSnackbar } from "notistack"
import { RoboSuporte } from "../../../services/apiRobo"
import { erroMsg } from "../components/comum"

/** Estatísticas de atendimento (porte da rail 📈). */
export function Stats() {
    const { enqueueSnackbar } = useSnackbar()
    const [dados, setDados] = React.useState<any>(null)
    const [carregando, setCarregando] = React.useState(false)

    const carregar = React.useCallback(async () => {
        setCarregando(true)
        try {
            setDados(await RoboSuporte.estatisticas())
        } catch (e) {
            enqueueSnackbar(erroMsg(e), { variant: "error" })
        } finally {
            setCarregando(false)
        }
    }, [enqueueSnackbar])

    React.useEffect(() => {
        carregar()
    }, [carregar])

    const cards = [
        { rotulo: "Tickets abertos", valor: dados?.totalOpened },
        { rotulo: "Tickets fechados", valor: dados?.totalClosed },
        { rotulo: "Duração média (min)", valor: dados?.avgDurationMinutes },
        { rotulo: "Amostra", valor: dados?.durationSampleSize },
        { rotulo: "Pendentes", valor: dados?.pendentes ?? dados?.abertos },
        { rotulo: "Em atendimento", valor: dados?.emAtendimento },
    ]

    return (
        <section className="panel active" style={{ display: "block" }}>
            <div className="panel-actions">
                <h3 style={{ margin: 0 }}>📈 Estatísticas</h3>
                <button className="ghost" onClick={carregar}>
                    ↻ Atualizar
                </button>
            </div>
            {carregando && <div className="muted small" style={{ padding: 12 }}>Carregando…</div>}
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10, padding: 12 }}>
                {cards.map(c => (
                    <div
                        key={c.rotulo}
                        style={{
                            flex: "1 1 150px",
                            minWidth: 140,
                            background: "var(--panel)",
                            border: "1px solid var(--border)",
                            borderRadius: "var(--radius)",
                            padding: 14,
                            textAlign: "center",
                        }}
                    >
                        <div style={{ fontSize: 26, fontWeight: 700, color: "var(--text)" }}>
                            {c.valor ?? "—"}
                        </div>
                        <div className="muted small">{c.rotulo}</div>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default Stats
